import React, { useState } from 'react';
import { Box, Button, Card, CardContent, Stack, Typography } from '@mui/material';
import BillingDialog from './BillingDialog';

export default function AccessBlocked({ user }) {
  const [open, setOpen] = useState(false);
  const vencimento = user?.expiraEm ? new Date(user.expiraEm) : null;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f0f2f5',
        p: 2
      }}
    >
      <Card sx={{ maxWidth: 520, width: '100%', borderRadius: 4, boxShadow: 6 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h5" fontWeight="bold" color="error.main">
              Acesso bloqueado por falta de pagamento
            </Typography>
            <Typography color="textSecondary">
              Para voltar a usar a plataforma, finalize o pagamento em um dos planos abaixo.
            </Typography>
            {vencimento && (
              <Typography variant="body2" color="textSecondary">
                Seu último vencimento foi em {vencimento.toLocaleDateString('pt-BR')}.
              </Typography>
            )}
            <Button variant="contained" onClick={() => setOpen(true)}>
              Regularizar agora
            </Button>
            <Typography variant="body2" color="textSecondary">
              Dica: pagamentos por Pix são aprovados em poucos segundos. Parcelas no cartão seguem juros do emissor.
            </Typography>
          </Stack>
        </CardContent>
      </Card>

      <BillingDialog open={open} onClose={() => setOpen(false)} user={user} />
    </Box>
  );
}
